import Default from './default';

class Home extends Default {
	namespace = 'home';

	beforeEnter = data => {
		super.beforeEnter(data);
		const scope = data.next.container;
		this.initSlider(scope);
	};

	afterEnter = data => {
		super.afterEnter(data);
	};

	beforeLeave = data => {
		super.beforeLeave(data);
	};

	afterLeave = data => {
		super.afterLeave(data);
	};

	initSlider = scope => {
		const $slider = $(scope).find('[data-slider="el"]');

		if ($slider.length) {
			// dynamically import slider
			import(/* webpackChunkName: "slider" */ '../components/slider').then(
				module => {
					this.slider = new module.default($slider);
				}
			);
		}
	};
}

export default new Home();
